var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachmentIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 19.75C10.7279 19.75 13.75 16.7279 13.75 13L13.75 5C13.75 2.37665 11.6234 0.25 9 0.25C6.37665 0.25 4.25 2.37665 4.25 5L4.25 13.1429C4.25 14.6616 5.48122 15.8929 7 15.8929C8.51878 15.8929 9.75 14.6616 9.75 13.1429L9.75 5.28571C9.75 4.8715 9.41421 4.53571 9 4.53571C8.58579 4.53571 8.25 4.8715 8.25 5.28571L8.25 13.1429C8.25 13.8332 7.69036 14.3929 7 14.3929C6.30964 14.3929 5.75 13.8332 5.75 13.1429L5.75 5C5.75 3.20507 7.20508 1.75 9 1.75C10.7949 1.75 12.25 3.20507 12.25 5L12.25 13C12.25 15.8995 9.89949 18.25 7 18.25C4.1005 18.25 1.75 15.8995 1.75 13L1.75 5.28571C1.75 4.8715 1.41421 4.53571 1 4.53571C0.585787 4.53571 0.250001 4.8715 0.250001 5.28571L0.25 13C0.25 16.7279 3.27208 19.75 7 19.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentIcon);
export default __webpack_public_path__ + "static/media/AttachmentIcon.e7108a174702a524b4e7c381cb677977.svg";
export { ForwardRef as ReactComponent };